import {
  GraphQLFieldConfig,
  GraphQLNonNull,
  GraphQLObjectType,
  GraphQLList,
  GraphQLString,
  GraphQLID
} from 'graphql'
import { Context } from '../shared'

export type Tutorial =
  | 'APPLICATIONS'
  | 'APP_OVERVIEW'
  | 'APP_LIBRARIES'
  | 'APP_VULNERABILITIES'
  | 'ATTACKS'

export const tutorialsResponseType = new GraphQLObjectType({
  name: 'TutorialsResponse',
  fields: () => ({
    tutorials: {
      description: 'The list of tutorials viewed',
      type: new GraphQLNonNull(new GraphQLList(GraphQLString))
    }
  })
})

interface TutorialsArgs {
  readonly organizationID: string
}

export const tutorialsArgs = {
  organizationID: {
    description: 'The Organization Id',
    type: new GraphQLNonNull(GraphQLID)
  }
}

export const tutorials: GraphQLFieldConfig<any, Context, TutorialsArgs> = {
  description: 'Get tutorials viewed by user.',
  type: new GraphQLNonNull(tutorialsResponseType),
  args: tutorialsArgs,
  async resolve(_source, args, context): Promise<Tutorial[]> {
    const { organizationID: orgUuid } = args
    const { connector } = context
    return connector.get(`/${orgUuid}/onboarding/tutorial`)
  }
}
